<template>
  <!--  <BaseTableColumn-->
  <!--    label="Picture"-->
  <!--    is-toggable-->
  <!--    #="{ rowData }"-->
  <!--    :content-class="$style.pictureCell"-->
  <!--  >-->
  <!--    <div-->
  <!--      :class="$style.picture"-->
  <!--      :style="{ backgroundImage: `url(${rowData.picture})` }"-->
  <!--    />-->
  <!--  </BaseTableColumn>-->

  <BaseTableColumn
    label="Name"
    header="Name"
    #="{ rowData }"
  >
    {{ rowData.givenName }}
    <template v-if="rowData.id === user.username">
      <BaseLabel
        :class="$style.youMark"
        color="cherry"
      >
        You
      </BaseLabel>
    </template>
    <template v-else>
      {{ rowData.familyName }}
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    label="Email"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TableJigsawSvg /> Email
      </TableHeaderWithIcon>
    </template>

    <template #default="{ rowData }">
      {{ rowData.email }}
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    label="Company"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TableCommercialSvg /> Company
      </TableHeaderWithIcon>
    </template>

    <template #default="{ rowData }">
      {{ rowData.company?.name }}
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    label="Creation date"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TableDateStartSvg /> Creation date
      </TableHeaderWithIcon>
    </template>

    <template #default="{ rowData }">
      {{ format(new Date(rowData.created_at), 'd MMMM y') }}
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    label="Role"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TablePhaseSvg /> Role
      </TableHeaderWithIcon>
    </template>

    <template #default="{ rowData }">
      <div :class="$style.roles">
        <BaseLabel
          color="aqua"
        >
          User
        </BaseLabel>

        <BaseLabel
          v-if="rowData.company?.owner_id === rowData.id"
          color="orange"
        >
          Billing
        </BaseLabel>

        <BaseLabel
          v-if="rowData.groups.includes('Admin')"
          color="lime"
        >
          Admin
        </BaseLabel>

        <BaseLabel
          v-if="rowData.groups.includes('Client-admin')"
          color="lime"
        >
          Company Admin
        </BaseLabel>
      </div>
    </template>
  </BaseTableColumn>

  <BaseTableActionsColumn #="{ rowData, tippy }">
    <BaseDropdownActionsList>
      <router-link
        #="{ navigate }"
        :to="{ name: 'Users/Edit', params: { userId: rowData.id } }"
        custom
      >
        <BaseDropdownAction @click="navigate">
          Edit
        </BaseDropdownAction>
      </router-link>
      <BaseDropdown>
        <template #trigger>
          <BaseDropdownAction>
            Delete
          </BaseDropdownAction>
        </template>

        <template #content="{ tippy: tippyConfirm }">
          <BaseDropdownActionsList>
            <BaseDropdownAction @click="actAndClose([tippy, tippyConfirm], disable, rowData.id)">
              Confirm
            </BaseDropdownAction>
            <BaseDropdownAction @click="tippyConfirm.hide">
              Cancel
            </BaseDropdownAction>
          </BaseDropdownActionsList>
        </template>
      </BaseDropdown>
    </BaseDropdownActionsList>
  </BaseTableActionsColumn>
</template>

<script>
import { format } from 'date-fns';
import { mapState } from 'vuex';
import { isArray } from 'lodash';
import {
  TableColumn as BaseTableColumn,
  TableActionsColumn as BaseTableActionsColumn,
} from '@/components/base/Table';
import BaseDropdown, {
  DropdownActionsList as BaseDropdownActionsList,
  DropdownAction as BaseDropdownAction,
} from '@/components/base/Dropdown';
import BaseLabel from '@/components/base/Label';
import TableHeaderWithIcon from '@/components/TableHeaderWithIcon';
import TableJigsawSvg from '@/assets/images/icons/table-jigsaw.svg?inline';
import TableCommercialSvg from '@/assets/images/icons/table-commercial.svg?inline';
import TableDateStartSvg from '@/assets/images/icons/table-date-start.svg?inline';
import TablePhaseSvg from '@/assets/images/icons/table-phase.svg?inline';

export default {
  components: {
    BaseTableColumn,
    BaseTableActionsColumn,
    BaseDropdown,
    BaseDropdownActionsList,
    BaseDropdownAction,
    BaseLabel,
    TableHeaderWithIcon,
    TableJigsawSvg,
    TableCommercialSvg,
    TableDateStartSvg,
    TablePhaseSvg,
  },
  emits: {
    disable: null,
  },
  computed: {
    ...mapState('user', ['user']),
  },
  methods: {
    format,
    actAndClose(tippy, method, ...args) {
      const dropdowns = isArray(tippy) ? tippy : [tippy];
      dropdowns.forEach((x) => x.hide());
      method(...args);
    },
    disable(username) {
      this.$emit('disable', username);
    },
  },
};
</script>

<style lang="scss" module>
.pictureCell {
  width: 53px;
}

.picture {
  display: inline-block;
  width: 32px;
  height: 32px;
  margin: -7px -15px -6px 0;
  background-position: center;
  background-size: cover;
  border: 1px solid $text-dark;
  border-radius: 50%;
}

.youMark {
  margin-top: -2px;
  margin-left: 5px;
}

.roles {

  > * {

    &:not(:first-child) {
      margin-left: 5px;
    }
  }
}
</style>
